export default [
  {
    type: 'line',
    data: {
      labels: '',
      datasets: [
        {
          data: [],
          borderWidth: 2,
          backgroundColor: '#1BA7C9',
          borderColor: '#1BA7C9',
          fill: false,
          showLines: true,
        },
      ],
    },
    options: {
      animation: false,
      tooltips: {
        callbacks: {
          label: (item) => ` ${item.yLabel}回`,
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      maintainAspectRatio: false,

      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              unit: '',
              displayFormats: {
                day: 'MM/DD',
                month: 'YYYY/MM',
              },
            },
            ticks: {
              source: 'labels',
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              suggestedMax: 10,
            },
          },
        ],
      },
    },
  },
  {
    type: 'line',
    data: {
      labels: '',
      datasets: [
        {
          data: [],
          borderWidth: 2,
          backgroundColor: '#1BA7C9',
          borderColor: '#1BA7C9',
          fill: false,
          showLines: true,
        },
      ],
    },
    options: {
      animation: false,
      tooltips: {
        callbacks: {
          label: (item) => ` ${item.yLabel}人`,
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      maintainAspectRatio: false,

      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              unit: '',
              displayFormats: {
                day: 'MM/DD',
                month: 'YYYY/MM',
              },
            },
            ticks: {
              source: 'labels',
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              suggestedMax: 10,
            },
          },
        ],
      },
    },
  },
]
